import type { AuthStatus, DeployStatus, MetricSummary, ProjectAction, ProjectsResponse } from './types'

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, { credentials: 'same-origin', ...options, headers: { 'Content-Type': 'application/json', ...options?.headers } })
  const body = await response.json().catch(() => ({})) as { error?: string }
  if (!response.ok) throw new Error(body.error || `Request failed (${response.status})`)
  return body as T
}

export const api = {
  auth: () => request<AuthStatus>('/api/auth/status'),
  signIn: (email: string, password: string) => request<AuthStatus>('/api/auth/sign-in', { method: 'POST', body: JSON.stringify({ email, password }) }),
  signOut: () => request<{ ok: true }>('/api/auth/sign-out', { method: 'POST' }),
  metric: (path: string) => request<{ ok: true }>('/api/metrics/event', { method: 'POST', body: JSON.stringify({ path }) }),
  metrics: (days: number) => request<MetricSummary>(`/api/admin/metrics?days=${days}`),
  deploy: () => request<DeployStatus>('/api/admin/deploy'),
  startDeploy: (commit?:string) => request<{started:boolean}>('/api/admin/deploy', { method:'POST', body:JSON.stringify({commit}) }),
  projects: () => request<ProjectsResponse>('/api/admin/projects'),
  projectAction: (id:string,action:ProjectAction) => request<{started:boolean;completed?:boolean}>(`/api/admin/projects/${encodeURIComponent(id)}/actions`,{method:'POST',body:JSON.stringify({action})}),
}
